import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { providerInfo, whyChooseUs } from '../../mock';
import { iconMap } from './iconMap';

export const WhyChooseUs = () => (
  <section id="about" data-testid="why-choose-us-section" className="fade-in-section py-12 md:py-20 px-4 bg-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto relative z-10">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Why Choose Us?</h2>
        <div className="w-24 h-1 bg-primaryOrange mx-auto"></div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-10 md:mb-16">
        <div className="order-2 md:order-1">
          <div className="relative rounded-2xl overflow-hidden shadow-xl bg-white p-2 md:p-4">
            <img
              src="https://customer-assets.emergentagent.com/job_26f08e10-1414-438b-96d5-f47b988c9439/artifacts/emfut4b5_Photo%202.jpg"
              alt="Healthcare Provider"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
        <div className="order-1 md:order-2 space-y-4 md:space-y-6">
          <h3 className="text-2xl md:text-3xl font-bold text-darkBrown">{providerInfo.name}</h3>
          <p className="text-base md:text-lg text-primaryOrange font-semibold">{providerInfo.credentials}</p>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">{providerInfo.description}</p>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">{providerInfo.philosophy}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
        {whyChooseUs.map((item, index) => {
          const Icon = iconMap[item.icon];
          return (
            <Card
              key={item.id}
              className="border-none shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 bg-warmBeige"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardHeader className="p-3 md:p-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-primaryOrange rounded-lg flex items-center justify-center mb-2 md:mb-4">
                  <Icon className="text-white" size={20} />
                </div>
                <CardTitle className="text-darkBrown text-sm md:text-base">{item.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
                <p className="text-xs md:text-sm text-gray-600">{item.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
